import MnthEndFAQ from "../components/MnthEndFAQ";
import Header from "../components/NewYearCamp2026";
import IplHeader from "../components/IplHeader";
import bg from "../images/chrBg.png"
import DailyQuiz from "../components/DailyQuiz";
import TermsAndCondition from "../components/TermsAndCondition";
// import Predict from "../components/predictTwo";
import Predict from "../components/IPL2024/index";
import TopStackers from "../components/TopStackers";
import MysteryRewards from "../components/MysteryRewards";
// import Predict from "../components/predict";
import FAQ from "../components/FAQ";
import PurchaseStreak from "./PurchaseStreak";
import faqDivider from '../images/faqDivider.png';
import FloatingButton from "../components/FloatingShareButton";
import JackpotRewards from "../components/jackpotRewards";
import republicDayCamp from "../RepublicDayCamp2025";
import { BsShareFill } from "react-icons/bs";
import * as APIHelper from '../Helper/apiFetch';
import * as nativeEvents from '../Helper/native';
import { DropdownDivider } from "react-bootstrap";

const initiaData = require('../components/urlEncodeTest.json');

export default function Home() {

    const shareWithFriends = () => {
        APIHelper.postAnalytics("share_from_home");
        nativeEvents.shareWithFriends(initiaData.floatingShareMsg.msg);
    }

    return (
        <div className="campBody">
            {/*  <div className="floatingShareButtonContainer">
                 <button className="floatingShareButton" onClick={() => shareWithFriends() }>
                    <BsShareFill  size={24} />
                    Share
                </button> 
            </div> */}
            {/* <republicDayCamp.LandingScreen /> */}
            {/* <Header /> */}

            <IplHeader />
            <div style={{ background: '#213686' }}>
                <div style={{ display: 'flex', padding: '50px 0px 20px 0px' }}>
                    <div className="rightDiv"></div>
                    <span style={{ margin: '0 10px' }}>QUIZ TRIVIA</span>
                    <div className="leftDiv"></div>
                </div>
                <DailyQuiz />
                <div style={{ display: 'flex', padding: '40px 0px 20px 0px' }}>
                    <div className="rightDiv"></div>
                    <span style={{ margin: '0 10px' }}>PREDICT AND WIN</span>
                    <div className="leftDiv"></div>
                </div>
                <Predict />
                <div style={{ display: 'flex', padding: '10px 0px 20px 0px' }}>
                    <div className="rightDiv"></div>
                    <span style={{ margin: '0 10px' }}>WEEKLY SPEND STREAK</span>
                    <div className="leftDiv"></div>
                </div>
                <PurchaseStreak />
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '60px' }}>
                    <img src={faqDivider} style={{ height: '24px', width: 'auto' }} />
                </div>
                <FAQ />
                <TermsAndCondition />

            </div>
            {/* <JackpotRewards /> */}
            {/* <TopStackers /> */}
            {/* <div className="divider"></div> */}
            {/* <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <TermsAndCondition />
                <button className="footerShareButton" onClick={() => shareWithFriends()}>
                    <BsShareFill size={16} />  Share
                </button>
            </div> */}
            {/* <TermsAndCondition /> */}
        </div>
    )
}